import { genericPage, getMappingProgramaSlug, isCr, getServerSidePropsHelper } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
///nom-bonic-programa/mes-info/
const pathTv = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'mes-info'];
const pathRadio = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'mes-info-radio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, pathTv);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    const path = isCr(mapping) ? pathRadio : pathTv;

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
